module.exports = __webpack_public_path__ + "static/media/jcb.8bb2d74d.svg";